import React, {useState} from 'react';

import {AppButton} from '../../../../components/Button';
import {Article} from '../../../../components/DataDisplay';
import {AboutDeviceRestrictedIcon, FaceIconBad, FaceIconExcellent, FaceIconGood} from '../../../../components/Icons';
import Input from '../../../../components/Input/Input';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import EmotionRadioGroup from './EmotionRadioGroup';

const emotionRadioTypesList = [
    {
        type: 'BAD',
        title: localizationKeys.FEEDBACK_MODAL_EMOTION_BUTTON_BAD,
        icon: FaceIconBad,
    },
    {
        type: 'GOOD',
        title: localizationKeys.FEEDBACK_MODAL_EMOTION_BUTTON_GOOD,
        icon: FaceIconGood,
    },
    {
        type: 'EXCELLENT',
        title: localizationKeys.FEEDBACK_MODAL_EMOTION_BUTTON_EXCELLENT,
        icon: FaceIconExcellent,
    },
];

const FeedbackPopupContent = ({onSubmitButtonClick}) => {
    const [selectedEmotionType, setSelectedEmotionType] = useState('');
    const [inputValue, setInputValue] = useState('');

    const localizedStrings = getLocalizedStrings();

    const onRadioChange = (type) => {
        setSelectedEmotionType(type);
    };

    const handleChangeInputValue = (event) => {
        setInputValue(event.target.value);
    };

    const handleSubmitEvent = () => {
        const feedbackData = {
            emotionType: selectedEmotionType,
            message: inputValue,
        };

        onSubmitButtonClick(feedbackData);
    };

    return (
        <Article
            titleClassName='text-18'
            descriptionClassName='text-14'
            titleKey={localizationKeys.FEEDBACK_MODAL_TITLE}
            descriptionKey={localizationKeys.FEEDBACK_MODAL_DESCRIPTION}
            icon={<AboutDeviceRestrictedIcon className='mb-4 md-max:hidden' />}
        >
            <EmotionRadioGroup
                ariaLabel={localizedStrings[localizationKeys.FEEDBACK_MODAL_EMOTION_RADIO_GROUP_ARIA_LABEL]}
                emotionRadioTypesList={emotionRadioTypesList}
                onRadioChange={onRadioChange}
                selectedType={selectedEmotionType}
            />
            <Input
                className='h-12 w-full border-2 border-border px-5 py-4 text-left text-12 placeholder-primary rtl:text-right'
                placeholder={localizedStrings[localizationKeys.FEEDBACK_MODAL_INPUT_PLACEHOLDER_TEXT]}
                ariaLabel={localizedStrings[localizationKeys.FEEDBACK_MODAL_INPUT_ARIA_LABEL]}
                onChange={handleChangeInputValue}
                value={inputValue}
            />
            <AppButton
                className='mt-8 md:mt-4'
                onClick={handleSubmitEvent}
                disabled={!selectedEmotionType}
                ariaLabel={localizedStrings[localizationKeys.FEEDBACK_MODAL_BUTTON_ARIA_LABEL]}
                primary
                light
            >
                {localizedStrings[localizationKeys.FEEDBACK_MODAL_BUTTON]}
            </AppButton>
        </Article>
    );
};

export default FeedbackPopupContent;
